








































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import CustomerService from '@/domain/customer/service/customer.service';
import Customer from '@/domain/customer/entity/customer.entity';
import PaymentFileFilter from '@/domain/payment/entity/payment-file-filter.entity';
import MainButton from '@/shared/buttons/main-button.component.vue';
import Pagination from '@/domain/pagination.entity';
import DatePickerMonthYear from '@/shared/date-picker/date-picker-month-year.component.vue'

@Component({ components: { MainButton, DatePickerMonthYear } })
export default class PaymentFileFilterComponent extends Vue {
  @Prop({
    required: true,
    default: '',
  })
  filter!: PaymentFileFilter;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  customers: Array<Customer> = [];

  lastFilteredName: string = '';

  clear() {
    const { filters }: any = this.$refs;
    filters.reset();
    this.search();
  }

  search() {
    this.$emit('search');
  }

  updateField(field: string, value: any): void {
    this.$emit(`update:${field}`, value);
  }

  getCustomers(name: string) {
    if (name && name.length >= 3 && name !== this.lastFilteredName) {
      this.lastFilteredName = name;
      CustomerService.getByTradingNameOrName(new Pagination({
        page: 1,
        itemsPerPage: 100,
        defaultSort: 'name|asc',
      }), name,
      'name',
      this.businessUnitId)
        .then((response: any) => {
          this.customers = Customer.ofList(response.content)
        });
    }
  }
}

